import React from "react";
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  Typography,
  Divider,
} from "@mui/material";
import { Category, Business } from "@mui/icons-material";

const CategoryBrandFilter = ({
  category,
  brand, // ✅ NUEVO: Filtro de marca
  model, // ✅ ACTUALIZADO: Filtro de modelo
  categories,
  brands, // ✅ NUEVO: Array de marcas
  models, // ✅ ACTUALIZADO: Array de modelos
  onCategoryChange,
  onBrandChange, // ✅ NUEVO: Callback para marca
  onModelChange, // ✅ ACTUALIZADO: Callback para modelo
}) => {
  // 🔧 FIX: Validar valores para evitar warnings de MUI
  const getValidValue = (value, availableOptions, defaultValue = "Todas") => {
    if (!availableOptions || availableOptions.length === 0) return defaultValue;

    // Si el valor actual existe en las opciones, usarlo
    const valueExists = availableOptions.some((option) => {
      if (typeof option === "string") return option === value;
      if (typeof option === "object" && option !== null) {
        return option.name === value || option.id === value || option === value;
      }
      return false;
    });

    return valueExists ? value : defaultValue;
  };

  // Valores validados para evitar warnings de MUI
  const validatedCategory = getValidValue(category, categories);
  const validatedBrand = getValidValue(brand, brands);
  const validatedModel = getValidValue(model, models);

  // ✅ Función helper para manejar categorías que pueden ser strings u objetos
  const renderCategoryOptions = () => {
    if (!categories || categories.length === 0) return null;

    return categories
      .map((cat) => {
        // Si es un objeto con estructura {id, name}
        if (typeof cat === "object" && cat !== null) {
          const key =
            cat.id && cat.name
              ? `${cat.id}-${cat.name}`
              : cat.name || cat.id || JSON.stringify(cat);
          const value = cat.name || cat.id || cat;
          const label = cat.name || cat.id || "Sin nombre";

          return (
            <MenuItem key={key} value={value}>
              {label}
            </MenuItem>
          );
        }
        // Si es un string simple (fallback para compatibilidad)
        else if (typeof cat === "string") {
          return (
            <MenuItem key={cat} value={cat}>
              {cat}
            </MenuItem>
          );
        }
        // Evitar renderizar valores inválidos
        return null;
      })
      .filter(Boolean); // Filtrar valores null
  };

  // ✅ Función helper para manejar modelos que pueden ser strings u objetos
  const renderModelOptions = () => {
    if (!models || models.length === 0) return null;

    return models
      .map((model) => {
        // Si es un objeto con estructura {id, name}
        if (typeof model === "object" && model !== null) {
          const key =
            model.id && model.name
              ? `${model.id}-${model.name}`
              : model.name || model.id || JSON.stringify(model);
          const value = model.name || model.id || model;
          const label = model.name || model.id || "Sin nombre";

          return (
            <MenuItem key={key} value={value}>
              {label}
            </MenuItem>
          );
        }
        // Si es un string simple (fallback para compatibilidad)
        else if (typeof model === "string") {
          return (
            <MenuItem key={model} value={model}>
              {model}
            </MenuItem>
          );
        }
        // Evitar renderizar valores inválidos
        return null;
      })
      .filter(Boolean); // Filtrar valores null
  };

  // ✅ Función helper para manejar marcas que pueden ser strings u objetos
  const renderBrandOptions = () => {
    if (!brands || brands.length === 0) return null;

    return brands
      .map((brand) => {
        // Si es un objeto con estructura {id, name}
        if (typeof brand === "object" && brand !== null) {
          const key =
            brand.id && brand.name
              ? `${brand.id}-${brand.name}`
              : brand.name || brand.id || JSON.stringify(brand);
          const value = brand.name || brand.id || brand;
          const label = brand.name || brand.id || "Sin nombre";

          return (
            <MenuItem key={key} value={value}>
              {label}
            </MenuItem>
          );
        }
        // Si es un string simple (fallback para compatibilidad)
        else if (typeof brand === "string") {
          return (
            <MenuItem key={brand} value={brand}>
              {brand}
            </MenuItem>
          );
        }
        // Evitar renderizar valores inválidos
        return null;
      })
      .filter(Boolean); // Filtrar valores null
  };

  return (
    <>
      <Box sx={{ mb: 3 }}>
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
          <Category sx={{ fontSize: 16, mr: 0.5 }} />
          Categoría
        </Typography>
        <FormControl fullWidth>
          <Select
            value={validatedCategory}
            onChange={(e) => onCategoryChange(e.target.value)}
            size="small"
            MenuProps={{ disableScrollLock: true }}
          >
            {renderCategoryOptions()}
          </Select>
        </FormControl>
      </Box>

      {/* ✅ NUEVO: Filtro de Marca */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
          <Business sx={{ fontSize: 16, mr: 0.5 }} />
          Marca
        </Typography>
        <FormControl fullWidth>
          <Select
            value={validatedBrand}
            onChange={(e) => onBrandChange(e.target.value)}
            size="small"
            MenuProps={{ disableScrollLock: true }}
          >
            {renderBrandOptions()}
          </Select>
        </FormControl>
      </Box>

      {/* ✅ ACTUALIZADO: Filtro de Modelo */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
          <Business sx={{ fontSize: 16, mr: 0.5 }} />
          Modelo
        </Typography>
        <FormControl fullWidth>
          <Select
            value={validatedModel}
            onChange={(e) => onModelChange(e.target.value)}
            size="small"
            MenuProps={{ disableScrollLock: true }}
          >
            {renderModelOptions()}
          </Select>
        </FormControl>
      </Box>

      <Divider sx={{ my: 2 }} />
    </>
  );
};

export default CategoryBrandFilter;
